export class GeneralDirector {
  firstName!: string;
  lastName!: string;
  email!: string;
  constructor() {
  }
}
